import { IRequestorLA } from 'onboarding/classes/models/requestorLA'
import { onboardingRequestorApi } from 'onboarding/classes/services/api/OnboardingRequestorApi'
import { TRequestorFill } from 'onboarding/components/widgets/public/forms/models'

class RequestorService {
  public getByRequestId(requestId: number, force: boolean) {
    return onboardingRequestorApi.getByRequestId(requestId, force)
  }

  public getLAByRequestId(requestId: number, force: boolean) {
    return onboardingRequestorApi.getLAByRequestId(requestId, force)
  }

  public create(data: Partial<TRequestorFill>[]) {
    return onboardingRequestorApi.create(data)
  }

  public update(data: Partial<TRequestorFill>[]) {
    return onboardingRequestorApi.update(data)
  }

  public createLA(data: Partial<IRequestorLA>[]) {
    return onboardingRequestorApi.createLA(data)
  }

  public updateLA(data: Partial<IRequestorLA>[]): Promise<IRequestorLA[]> {
    return onboardingRequestorApi.updateLA(data)
  }
}

export const requestorService = new RequestorService()
